import React from "react";
import RulesBaseComponent from "../bases/RulesBaseComponent/RulesBaseComponent"
export default function RulesPage() { return <RulesBaseComponent/>; }
